import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AcademyLockup } from "@/components/academy/AcademyBrand";
import { Artwork } from "@/components/academy/Artwork";
import { PingDot, SoonStamp } from "@/components/academy/teaser/TeaserBits";
import { WaitlistForm } from "@/components/academy/teaser/WaitlistForm";
import { ACADEMY_TOPICS } from "@/lib/academy/content";
import { track } from "@/lib/academy/actions";
import { LABEL, TEXT_LINK } from "@/lib/academy/ui";

const TeaserCard = () => (
  <div data-testid="home-academy-teaser-card" className="lg:col-span-5 academy-card overflow-hidden">
    <div className="relative h-[170px] border-b hairline bg-[#F7F8F9] text-[#160907] overflow-hidden">
      <Artwork direction="serverHall" className="absolute inset-0 w-full h-full" />
      <span aria-hidden="true" className="teaser-scan" />
      <SoonStamp className="absolute right-4 top-4" />
    </div>
    <div className="p-6 md:p-7">
      <p className={LABEL}>On the syllabus</p>
      <ul className="mt-4 flex flex-wrap gap-2">
        {ACADEMY_TOPICS.map((topic) => <li key={topic} className="inline-flex items-center gap-2 border border-[rgba(22,9,7,0.2)] bg-white px-3 py-1.5 font-space-mono text-[10px] text-[#160907]"><span aria-hidden="true" className="academy-node !w-[5px] !h-[5px]" />{topic}</li>)}
      </ul>
      <p className="mt-5 pt-4 border-t hairline text-sm text-[#3D4049]">No launch date yet. Joining the waitlist is free.</p>
    </div>
  </div>
);

export const HomeTeaser = () => (
  <section id="academy" data-testid="home-academy-feature" aria-labelledby="home-academy-title" className="academy-feature academy-brand academy-field border-b hairline overflow-hidden scroll-mt-20" data-chat-safe-area="phone">
    <div aria-hidden="true" className="teaser-glow" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-12 items-center">
      <div className="lg:col-span-7 min-w-0">
        <div className="flex flex-wrap items-end gap-x-5 gap-y-4">
          <AcademyLockup id="home-academy-brand" className="w-[min(62vw,250px)] sm:w-[340px]" />
          <span data-testid="home-academy-soon-badge" className="inline-flex items-center gap-2 border-[1.5px] border-[#160907] bg-white px-3 py-1.5 font-space-mono text-[10px] font-bold text-[#160907] mb-1"><PingDot />Coming soon</span>
        </div>
        <h2 id="home-academy-title" data-testid="home-academy-headline" className="mt-10 font-display text-[1.7rem] sm:text-4xl lg:text-[2.75rem] leading-[1.15] sm:leading-[1.15] text-[#160907] text-balance">Learn the Industry Behind AI</h2>
        <p data-testid="home-academy-copy" className="mt-5 max-w-xl text-base sm:text-lg text-[#3D4049] leading-relaxed">DCYB Academy is on the way: practical lessons on the systems, businesses and careers powering digital infrastructure. Be the first to know when it opens.</p>
        <WaitlistForm source="home" testId="home-academy-waitlist" className="mt-8 max-w-xl" />
        <Link to="/academy" data-testid="home-academy-teaser-link" onClick={() => track("academy_cta_clicked", { cta: "home_teaser" })} className={`mt-4 ${TEXT_LINK}`}>See what's coming<ArrowRight size={14} aria-hidden="true" /></Link>
      </div>
      <TeaserCard />
    </div>
  </section>
);
